// Rejilla de los datos del plan del cliente: 2 columnas en móvil, 3 en tablet y 5 en escritorio.
// `minmax(0, 1fr)` es obligatorio: sin él las celdas no bajan de su min-content, la fila desborda
// el ancho de la pantalla y a 375px empuja TODA la página (contenido encajonado y franjas del
// lienzo a los lados). La comparte el skeleton para que la carga ocupe el mismo espacio.
const planGridSx = {
  display: 'grid',
  gridTemplateColumns: {
    xs: 'repeat(2, minmax(0, 1fr))',
    sm: 'repeat(3, minmax(0, 1fr))',
    md: 'repeat(5, minmax(0, 1fr))'
  },
  gap: 1.5,
  marginBottom: 3
};

export default planGridSx;
